class RecommendedProductsSection extends HTMLElement {
  connectedCallback() {
    const swiperElement = this.querySelector('.swiper');
    if (!swiperElement || swiperElement.dataset.isLoaded === 'true' || typeof Swiper === 'undefined') {
      return;
    }
    const swiperOptions = {
      loop: false,
      slidesPerView: 1.33,
      spaceBetween: 24,
    };
    const swiper = new Swiper(swiperElement, swiperOptions);
    swiper.on('slideChange', function () {
      const currentIndex = this.activeIndex + 1;
      handleRecommendedNavigation(currentIndex);
    });
    swiperElement.dataset.isLoaded = 'true';
  }
}
customElements.define('cart-drawer-recommended-products', RecommendedProductsSection);

(() => {
  const sectionsToRender = [
    {
      section_id: 'cart-drawer',
      selectors: ['.drawer__header', 'cart-drawer-items', '.drawer__footer'],
    },
    {
      section_id: 'cart-icon-bubble',
      selectors: ['.cart-count-bubble'],
    },
  ];

  async function updateLiveContent(updatedSections) {
    try {
      for (const section of sectionsToRender) {
        const content = updatedSections[section.section_id];
        const html = new DOMParser().parseFromString(content, 'text/html');
        section.selectors.forEach((selector) => {
          const targetElement = document.querySelector(selector);
          const sourceElement = html.querySelector(selector);
          if (sourceElement.classList.contains('is-empty')) {
            sourceElement.classList.remove('is-empty');
          }
          if (targetElement && sourceElement) {
            targetElement.replaceWith(sourceElement);
          }
        });
      }
    } catch (e) {
      console.error(e);
    }
  }
  async function cartAddItem(variantId) {
    try {
      const body = JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: sectionsToRender.map((section) => section.section_id),
      });
      const response = await fetch(routes.cart_add_url, { ...fetchConfig(), ...{ body } });
      const data = await response.json();
      if (data.items.length > 0) {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) cartDrawer.classList.remove('is-empty');
      }
      await updateLiveContent(data.sections);
    } catch (e) {
      console.error(e);
    }
  }
  async function addRecommendedToCart(event) {
    // debugger;
    event.preventDefault();
    const parentCard = event.target.closest('.recommended-product__card');
    parentCard.classList.add('--loading');
    try {
      const variantId = event.currentTarget.dataset.variantId;
      if (!variantId) {
        throw new Error('Variant ID not found');
      }
      await cartAddItem(variantId, 1);
    } catch (e) {
      console.error(e);
    }
  }

  function handleRecommendedNavigation(index) {
    const wrapper = document.querySelector('#recommendedProducts');
    const slider = wrapper.querySelector('.recommended-products.swiper');
    const total_slides = wrapper.querySelectorAll('.swiper-slide').length;
    const current_index = parseInt(slider.dataset.currentIndex);
    let next_index = null;
    if (index === 'next') {
      next_index = current_index + 1;
      const nextSlide = wrapper.querySelector(`.swiper-slide[data-slider-index="${next_index}"]`);
      if (!nextSlide) return;
      slider.setAttribute('data-current-index', next_index);
    } else if (index == 'prev') {
      next_index = current_index - 1;
      const prevSlide = wrapper.querySelector(`.swiper-slide[data-slider-index="${next_index}"]`);
      if (prevSlide) {
        slider.setAttribute('data-current-index', next_index);
      }
    } else {
      next_index = index;
      const slide = wrapper.querySelector(`.swiper-slide[data-slider-index="${index}"]`);
      if (slide) {
        slider.setAttribute('data-current-index', index);
      }
    }
    // update the navigation buttons
    const prevButton = wrapper.querySelector('.drawer__slider-controls .navigation_arrows .--arrow_prev');
    const nextButton = wrapper.querySelector('.drawer__slider-controls .navigation_arrows .--arrow_next');
    if (next_index == 1) {
      prevButton.setAttribute('disabled', 'disabled');
    } else {
      prevButton.removeAttribute('disabled');
    }
    if (next_index == total_slides) {
      nextButton.setAttribute('disabled', 'disabled');
    } else {
      nextButton.removeAttribute('disabled');
    }

    // update dots
    const dots = wrapper.querySelectorAll('.control__dot');
    dots.forEach((dot) => {
      const dotIndex = parseInt(dot.dataset.dotIndex);
      if (dotIndex == next_index) {
        dot.classList.add('active');
      } else {
        dot.classList.remove('active');
      }
    });

    // upadte pagination
    const currentPage = wrapper.querySelector('.current_page');
    currentPage.textContent = next_index;
    // console.log({ index, next_index, current_index, total_slides });

    const swiper = slider.swiper;
    if (swiper) {
      if (index === 'next') {
        swiper.slideNext();
      } else if (index === 'prev') {
        swiper.slidePrev();
      } else {
        swiper.slideTo(index - 1);
      }
    }
  }
  window.handleRecommendedNavigation = handleRecommendedNavigation;
  window.addRecommendedToCart = addRecommendedToCart;
})();
